import React from "react";
import { ProducerPaymentReportSummaryTemplate } from "themes/administration/producer/components";

function ProducerPaymentReportSummary(props) {
    return <ProducerPaymentReportSummaryTemplate {...props} />;
}

export default ProducerPaymentReportSummary;
